import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

import { temChaveVigente } from '../utils/regrasDaTela';

const selectChavesDeApiState = (state: RootState) => state.chavesDeApi;

export const selectChavesDeApi = (state: RootState) => state.chavesDeApi.chaves;
export const selectChavesCarregadoPara = (state: RootState) => state.chavesDeApi.carregadoPara;
export const selectChavesCarregando = (state: RootState) => state.chavesDeApi.carregando;
export const selectChavesErro = (state: RootState) => state.chavesDeApi.erro;
export const selectChavesAcaoEmCurso = (state: RootState) => state.chavesDeApi.acaoEmCurso;
export const selectChavesErroDaAcao = (state: RootState) => state.chavesDeApi.erroDaAcao;

export const selectTemChaveVigente = createSelector(selectChavesDeApiState, (estado) =>
  temChaveVigente(estado.chaves),
);
